import { Outlet } from "react-router-dom";

const Roles = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Roles;
